"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mbMinified = void 0;
const client_1 = require("../utils/queryParams/client");
const mbMinified = (isDebug) => (isDebug || (0, client_1.hasDebugParam)() ? '' : '.min');
exports.mbMinified = mbMinified;
//# sourceMappingURL=mbMinified.js.map